
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6","cy":"6","r":"5.5","stroke":"#172542"}}),_c('path',{attrs:{"d":"M5.403 9.198V4.392h1.125v4.806H5.403zM5.97 3.6a.725.725 0 01-.522-.198.65.65 0 01-.198-.477c0-.192.066-.351.198-.477a.725.725 0 01.522-.198c.21 0 .381.063.513.189.138.12.207.273.207.459a.702.702 0 01-.198.504.706.706 0 01-.522.198z","fill":"#172542"}})])
          )
        }
      }
    